// extracted by mini-css-extract-plugin
export default {"brand":"BrandInsights_brand__qY3Il","brand_specs":"BrandInsights_brand_specs__gf1IY","partition":"BrandInsights_partition__lX8mg"};